(function() {
    function toggleExpander(expanders) {
        expanders.forEach(function(item) {
            item.addEventListener('click', function() {
                // 1. Toggle the active class on the clicked row itself
                this.classList.toggle('ontario-expander--active');
                // 2. Find the content row (the next sibling in the table)
                var content = this.parentNode.parentNode.nextElementSibling;
		console.log(content);
                if (content && content.getAttribute('data-toggle') === 'ontario-expander-content') {
                    // Toggle a class for potential CSS transitions
                    content.classList.toggle('ontario-hide');

                    // Update Accessibility attributes
                    var isOpened = content.classList.contains('ontario-expander__content--opened');
                    content.setAttribute('aria-hidden', !isOpened);
                    this.setAttribute('aria-expanded', isOpened);
                }
            });
        });
    }

    window.addEventListener('DOMContentLoaded', function() {
        var expandableItems = Array.prototype.slice.call(document.querySelectorAll("[data-toggle='table-row-collapse']"));
	toggleExpander(expandableItems);
    });
})();
